import {Navigate, useLocation} from 'react-router'

const SchoolToInstitute = () => {
  const location = useLocation()

  return (
    <Navigate
      to={
        location.pathname.startsWith('/school/')
          ? location.pathname.replace('/school/', '/institute/')
          : location.pathname
      }
    />
  )
}

export default SchoolToInstitute
